export default __webpack_public_path__ + "static/waxringandcastringonhand-7de6575724a7f468cefd2953a34ddc53.png";